// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__1HMnS","title":"FrontImage_title__RwyrJ"};